import { Map, Record, List } from 'immutable';
import { companySignInAction } from 'domain/companies/companiesActions';
import { erpsUpdateDataAdapter } from './helpers';
import { erpsAdapter } from './adapters';
import * as A from './settingsActions';
import { ERP_NAMES } from 'domain/companies/helpers';

import { signOutAction } from 'domain/env';

export const settingsTypes = Object.freeze({
  boolean: 'boolean',
  text: 'text',
  list: 'list',
  dynamic_list: 'dynamic_list',
  file: 'file',
  float: 'float',
  number: 'number',
  int: 'int',
  ftp_connection: 'ftp_connection',
  indexes_sync_time: 'indexes_sync_time',
  priority_additional_api_connection: 'priority_additional_api_connection',
});

export const keys = Object.values(ERP_NAMES);

const InitialState = Record({
  category: null,
  params: Map(),
  erps: Map(),
  endpoint: null,
  erpType: null,
  erpSettings: List(),
  erpCompanies: List(),
  isLoadingERPSetting: false,
  hasLoadedErpSettings: false,
});

export const reducer = {
  settings(state = InitialState(), action) {
    switch (action.type) {
      case companySignInAction.request:
        // Reset ERP settings when switching companies
        return state.set('erpSettings', List()).set('isLoadingERPSetting', false).set('hasLoadedErpSettings', false);

      case A.getCategory.success:
        return state.set('category', action.payload.category).mergeIn(['erps'], action.payload.erps);

      case A.setErpsAction.type:
        return state.mergeIn(['erps'], erpsAdapter(action.payload)).set('erpSettings', List());

      case A.updateConnectionsTable.success:
        return state.mergeIn(['erps'], erpsUpdateDataAdapter(action.payload, state.erps));

      case A.getSSOParams.success:
        return state.merge(action.payload);

      case A.getCurrentERPSettings.type:
        return state.set('isLoadingERPSetting', true);

      case A.setCurrentERPSettingsAction.request:
        return state.set('isLoadingERPSetting', true);

      case A.getCurrentERPSettings.success:
      case A.setCurrentERPSettingsAction.success:
        return state
          .set('erpSettings', action.payload)
          .set('isLoadingERPSetting', false)
          .set('hasLoadedErpSettings', true);

      case A.getCurrentERPSettings.failure:
        return state.set('erpSettings', List()).set('isLoadingERPSetting', false).set('hasLoadedErpSettings', false);

      case A.getCurrentERPCompaniesAction.success:
        return state.set('erpCompanies', action.payload);

      // update ftp connection value, find setting index and update value from payload
      case A.saveFTPConnectionAction.success:
        return state.updateIn(
          ['erpSettings', state.erpSettings.findIndex((item) => item.type === 'ftp_connection')],
          (item) => item.set('value', action.payload),
        );

      // Saved through its own endpoint, so the value is patched in place.
      case A.savePriorityAdditionalApiConnectionAction.success: {
        const index = state.erpSettings.findIndex(
          (item) => item.type === settingsTypes.priority_additional_api_connection,
        );

        return index === -1 ? state : state.setIn(['erpSettings', index, 'value'], action.payload);
      }

      case A.clearCategoryAction.success:
        return state.set('category', null).set('erps', Map());

      case A.syncErpIndexesAction.type: {
        return state.updateIn(
          ['erpSettings', state.erpSettings.findIndex(({ type }) => type === 'indexes_sync_time')],
          (item) => item.set('is_sync_running', true),
        );
      }

      case A.syncErpIndexesAction.success: {
        return state.updateIn(
          ['erpSettings', state.erpSettings.findIndex(({ type }) => type === 'indexes_sync_time')],
          (item) => item.set('is_sync_running', false).set('indexes_update_date', action.payload?.indexes_update_date),
        );
      }

      case signOutAction.success:
        return InitialState();

      default:
        return state;
    }
  },
};
